import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';
import { MainDialog, SearchableSelect } from '../../UI';
import { Button } from '@material-ui/core';
import useCheckMobileScreen from '../../../hooks/useWidth';
import { createLoadingSelector } from '../../../redux/Loading/LoadingSelector';
import { GET_ALL_FORMS } from '../../../redux/DynamicForms/DynamicFormsType';
const styles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
    },
    text: {
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.71',
        letterSpacing: 'normal',
        textAlign: 'right'
    },
    newForm: {
        fontFamily: 'inherit',
        fontSize: '17px',
        fontWeight: 'bold',
        color: '#232733',
        [theme.breakpoints.down(1025)]: {
            fontSize: '16px'
        }
    },
    selectFormMessage: {
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: '500',
        color: '#545e66'
    },
    selectForm: {
        marginTop: '21px',
        maxWidth: '400px',
        borderRadius: '4px',
        border: 'solid 1.5px rgba(206, 210, 214, 0.8)',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column'
    },
    selectFormName: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#232733',
        padding: '16px 24px',
        borderBottom: 'solid 1px rgba(206, 210, 214, 0.8)',
        cursor: 'pointer',
        '&:last-child': {
            borderBottom: 'unset'
        }
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100vh'
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 5px'
    },
    header: {
        marginBottom: '24px',
        fontFamily: 'inherit',
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '1.06',
        color: '#232733'
    },
    label: {
        fontFamily: 'inherit',
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '1.08',
        color: '#545e66'
    },
    buttonContainer: {
        width: '50%',
        display: 'flex',
        marginRight: 'auto',
        justifyContent: 'flex-end'
    }
}));

const NewForm = () => {
    const isMobile = useCheckMobileScreen();
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const { messages } = useContext(MessagesContext);
    const history = useHistory();
    const params = useParams();
    const patientId = params?.id;
    const path = `/${params.clinicId}/patient/${patientId}/forms/form`;
    const allForms = useSelector((state) => state.dynamicForms.allForms);
    const loadingSelector = createLoadingSelector(GET_ALL_FORMS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const [data, setData] = useState([]);
    const [value, setValue] = useState({ id: '', name: '' });

    useEffect(() => {
        if (allForms?.length) {
            setData(allForms?.map((item) => ({ id: item.name, name: item.title })));
        }
    }, [allForms]);

    const handleGetNewForm = (name, title) => {
        // const findEntry = entries?.find((item) => item.structure.name === name || value?.id);
        // dispatch(getFormStructureNew(name.length ? name : value?.id));
        history.replace({
            pathname: `${path}/${name.length ? name : value?.id}`,
            state: isMobile ? { isNew: true, title: value?.name } : { isNew: true, title: title }
        });
    };

    return (
        <>
            {isMobile ? (
                <>
                    {/* <NewFormButton handleClick={handleToggle} /> */}

                    <MainDialog
                        fullScreen
                        open={true}
                        goBack={() => history.replace(path)}
                        maxWidth="500"
                    >
                        <div className={classes.column}>
                            <h4 className={classes.header}>{messages.newForm}</h4>
                            <span className={classes.label}>{messages.selectForm}</span>
                            <SearchableSelect
                                width="100%"
                                optionsDirection="ltr"
                                optionalToUse
                                value={value}
                                options={data}
                                id="selectForm"
                                optionsLabel="name"
                                name="type"
                                setValue={(id) => {
                                    let findName = allForms?.find((item) => item.name === id);
                                    setValue({ id: id, name: findName?.title });
                                }}
                            />
                            <div className={classes.buttonContainer}>
                                <Button fullWidth variant="contained" onClick={handleGetNewForm}>
                                    {messages.nextStep}
                                </Button>
                            </div>
                        </div>
                    </MainDialog>
                </>
            ) : isLoading ? (
                <div className={classes.loadingContainer}>
                    <CircularProgress />
                </div>
            ) : !isLoading && !allForms?.length ? (
                <div className={classes.loadingContainer}>
                    <span>{messages.notFoundListOfForm}</span>
                </div>
            ) : (
                <>
                    <div className={classes.row}>
                        <span className={clsx(classes.text, classes.newForm)}>
                            {messages.newForm}
                        </span>
                    </div>
                    <div>
                        <span className={clsx(classes.text, classes.selectFormMessage)}>
                            {messages.selectForm}
                        </span>
                    </div>

                    <div className={classes.selectForm}>
                        {allForms?.map((item, index) => (
                            <span
                                className={clsx(classes.title, classes.selectFormName)}
                                key={index}
                                onClick={() => handleGetNewForm(item.name, item.title)}
                            >
                                {item.title}
                            </span>
                        ))}
                    </div>
                </>
            )}
        </>
    );
};

export default NewForm;
